import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Header from "../components/Header"; // ✅ ADD THIS
import {
  get_notifications,
  mark_as_read,
} from "../store/reducers/notificationReducer";

const Notification = () => {
  const dispatch = useDispatch();

  const { notifications, loading } = useSelector(
    (state) => state.notification
  );

  const { userInfo } = useSelector((state) => state.auth);
  console.log("user info:", userInfo);

  // 🔹 Load notifications from DB
  useEffect(() => {
    if (userInfo?.id) {
      dispatch(get_notifications(userInfo.id));
    }
  }, [dispatch, userInfo]);

  const handleRead = (id) => {
    dispatch(mark_as_read(id));
  };

  return (
    <>
      {/* ✅ HEADER */}
      <Header />

      {/* ✅ PAGE CONTENT */}
      <div className="w-full max-w-3xl mx-auto p-4 mt-6">
        <h2 className="text-2xl font-semibold mb-4">Notifications</h2>

        {loading ? (
          <p className="text-center mt-4">Loading notifications...</p>
        ) : notifications.length === 0 ? (
          <p className="text-gray-500 text-center">
            No notifications yet
          </p>
        ) : (
          <div className="space-y-3">
            {notifications.map((n) => (
              <div
                key={n._id}
                className={`border rounded-lg p-4 flex justify-between items-start gap-4 ${
                  n.isRead ? "bg-white" : "bg-blue-50"
                }`}
              >
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-800">
                    {n.title}
                  </h4>

                  <p className="text-gray-600 text-sm mt-1">
                    {n.message}
                  </p>

                  <p className="text-xs text-gray-400 mt-2">
                    {new Date(n.createdAt).toLocaleString()}
                  </p>

                  {n.link && (
                    <Link
                      to={n.link}
                      className="text-sm text-blue-600 mt-2 inline-block"
                    >
                      View details →
                    </Link>
                  )}
                </div>

                {!n.isRead && (
                  <button
                    onClick={() => handleRead(n._id)}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    Mark as read
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Notification;
